import styled from "@emotion/styled";
import { PopOver } from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledPopOver = styled(PopOver)`
  .MuiPopover-paper {
    overflow: visible;
  }
`;
